export class SoundRepository {
  play(soundPath: any): HTMLAudioElement {
    const audio = new Audio(soundPath);
    audio.play();
    return audio;
  }
  playWeightedSounds(sounds: Array<WeightedSound>) {
    const totalWeight = sounds.reduce((sum, sound) => sum + sound.weight, 0);
    const randomValue = Math.random() * totalWeight;
    let cumulativeWeight = 0;

    for (const sound of sounds) {
      cumulativeWeight += sound.weight;
      if (randomValue <= cumulativeWeight) {
        this.play(sound.soundPath);
        return;
      }
    }
    this.play(sounds[sounds.length - 1].soundPath);
  }
}

export interface WeightedSound {
  soundPath: string;
  weight: number;
}

export enum Sounds {
  correct250QuestionCoin = "Correct/250_Question/Coin.wav",
  correct250QuestionCorrect = "Correct/250_Question/correct.mp3",
  correct250QuestionPopBells = "Correct/250_Question/PopBells.mp3",
  correct500QuestionAppMoney1 = "Correct/500_Questions/AppMoney1.mp3",
  correct500QuestionAppMoney2 = "Correct/500_Questions/AppMoney2.mp3",
  correct500QuestionCashMachine = "Correct/500_Questions/CashMachine.mp3",
  correct500QuestionGlockSuccessDing = "Correct/500_Questions/GlockSuccessDing.mp3",
  correct750QuestionMoneyCoins1 = "Correct/750_Questions/MoneyCoins1.mp3",
  correct750QuestionMoneyCoins2 = "Correct/750_Questions/MoneyCoins2.mp3",
  correct750QuestionPopWin1 = "Correct/750_Questions/PopWin1.mp3",
  correct750QuestionPopWin2 = "Correct/750_Questions/PopWin2.mp3",
  correctDoublePoints250QuestionGamePops1 = "Correct/Double_Points/250_Question/GamePops1.mp3",
  correctDoublePoints250QuestionGamePops3 = "Correct/Double_Points/250_Question/GamePops3.wav",
  correctDoublePoints500QuestionDigitalLoading = "Correct/Double_Points/500_Questions/DigitalLoading.mp3",
  correctDoublePoints500QuestionDigitalText = "Correct/Double_Points/500_Questions/DigitalText.wav",
  correctDoublePoints500QuestionGamePops2 = "Correct/Double_Points/500_Questions/GamePops2.mp3",
  correctDoublePoints750QuestionCorrectAnswerRings = "Correct/Double_Points/750_Question/CorrectAnswerRings.mp3",
  correctPit250QuestionGamePops4 = "Correct/Pit/250_Question/GamePops4.wav",
  correctPit500QuestionGamePops5 = "Correct/Pit/500_Questions/GamePops5.wav",
  correctPit500QuestionStrongPunch2 = "Correct/Pit/500_Questions/StrongPunch2.wav",
  correctPit500QuestionSwordSlashA = "Correct/Pit/500_Questions/SwordSlashA.mp3",
  correctPit750QuestionGamePops6 = "Correct/Pit/750_Question/GamePops6.wav",
  correctPit750QuestionPopPoppingDown = "Correct/Pit/750_Question/PopPoppingDown.wav",
  endGame250750DifferenceWin1 = "EndGame/250_750_difference/Win1.mp3",
  endGame10002000DifferenceHappyFanfare = "EndGame/1000_2000_Difference/HappyFanfare.mp3",
  endGame10002000DifferenceWinFanfare = "EndGame/1000_2000_Difference/WinFanfare.wav",
  endGame10002000DifferenceWinning = "EndGame/1000_2000_Difference/Winning.mp3",
  endGame22502750DifferenceMoneyWinner = "EndGame/2250_2750_Difference/MoneyWinner.wav",
  endGame3000DifferenceEasyMoneyAlert = "EndGame/3000_Difference/Easy_Money_Alert_TTX020704.wav",
  endGameTieSword = "EndGame/Tie/Sword.wav",
  selectedLifelineAdditionalTimeClockMechanism = "Selected_Lifeline/Additional_Time/ClockMechanism.wav",
  selectedLifelineCallAFriendCellPhone = "Selected_Lifeline/Call_A_friend/Cell_Phone.wav",
  selectedLifelineCallAFriendPhoneRing = "Selected_Lifeline/Call_A_friend/Phone_Ring.wav",
  selectedLifelineCallAFriendTelephoneRing1 = "Selected_Lifeline/Call_A_friend/TelephoneRing1.wav",
  selectedLifelineCallAFriendTelephoneRing2 = "Selected_Lifeline/Call_A_friend/TelephoneRing2.wav",
  selectedLifelineCallAFriendTelephoneRing3 = "Selected_Lifeline/Call_A_friend/TelephoneRing3.wav",
  selectedLifelineDoublePointsPowerup = "Selected_Lifeline/Double_points/Powerup.wav",
  selectedLifelineInsuranceShield = "Selected_Lifeline/Insurance/sHIELD.wav",
  selectedLifelinePitShovel = "Selected_Lifeline/Pit/Shovel.wav",
  selectedLifelinePop = "Selected_Lifeline/Pop.wav",
  timerFastTick = "Timer/FastTick.wav",
  timerTimerTicks = "Timer/TimerTicks.mp3",
  timerTimesUp = "Timer/TimeIsUp.mp3",
  wrong250QuestionWrongAnswer2 = "Wrong/250_Question/WrongAnswer2.wav",
  wrong = "Wrong/Wrong.wav",
  wrongAnswer = "Wrong/WrongAnswer.mp3",
  wrongAnswer2 = "Wrong/WrongAnswer2.wav",
  wrongOption1 = "Wrong/WrongOption1.mp3",
  xAnsweredPop = "XAnswered/Pop.wav",
}

export function getSoundCompletePath(soundPath: string) {
  // process.env.PUBLIC_URL handles the base path of your app automatically
  return `${process.env.PUBLIC_URL}/sounds/${soundPath}`;
}
